import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ChatSupport from '../ChatSupport';
import './index.scss';
import update from '../../assets/lotties/update.json';
import service from '../../assets/lotties/service.json';
import Lottie from 'lottie-react';

export const ChatSupportTest: React.FC = () => {
    const { t } = useTranslation();
    const TIME_CHANGE_LOTTIE = 1000;
    const [typeLottie, setTypeLottie] = useState<{}>(update);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setTypeLottie(service);
        }, TIME_CHANGE_LOTTIE);

        () => {
            window.clearTimeout(timeout);
        };
    }, []);

    const lottie = () => {
        return <Lottie animationData={typeLottie} style={{ height: 96, width: 96 }} />;
    };
    return (
        <div className='ChatSupportTest'>
            <ChatSupport text={t('supportChatChecksAnswer')}></ChatSupport>
            <div className='ChatSupportTest__lottie'>{lottie()}</div>
        </div>
    );
};

export default ChatSupportTest;
